import p5 from "p5";
import { GameController } from "../base/GameController";
import { View } from "./View";

export class ViewNewNumber extends View {
    public constructor(protected p: p5, protected controller: GameController) {
        super();
    }

    public load() {
        document.addEventListener("keypress", this.on_keypress_func);
    }

    public unload() {
        document.removeEventListener("keypress", this.on_keypress_func);
    }

    public draw() {
        this.p.background(0);
        this.p.stroke(255);
        this.p.textSize(32);
        this.p.text("I have found a number you will never find!!", 100, 270);
        this.p.text("Ready?", 100, 300);

        this.p.text("Press ENTER to continue.", 100, 440);
    }

    private on_keypress_func = (event: KeyboardEvent): void => {
        if (event.key === "Enter") this.controller.ask_for_number();
    };
}